import { Component, OnInit } from '@angular/core';
import { AfterViewInit, OnDestroy, ViewChild } from '@angular/core';
import { ApiIntegration } from '../../_services/api.integration';
import { Globals } from '../../_models/globals';
import { DataTableDirective } from 'angular-datatables';
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Router, ActivatedRoute } from '@angular/router';
import { User } from '../../_models/user';
import { Register } from '../../_models/register';
import { Inventory } from '../../inventory';
import { KitComponent } from '../../_models/kitComponent';
import { ProductAttribute } from '../../_models/productAttribute';
import { Subject } from 'rxjs';
import { Product } from '../../_models/product';
import { Caller } from '../../_models/caller';
import * as _ from "lodash";
import { AlertService } from '../../_services/alert.service';

@Component({
  selector: 'app-seller-products-view',
  templateUrl: './seller-products-view.component.html',
  styleUrls: ['./seller-products-view.component.scss'],
})
export class SellerProductsViewComponent implements OnInit {

  historyActivities: any[] = [];
  productAttr: ProductAttribute = {
    digitalProduct: "",
    lotProduct: "",
    productNumberScans: "",
    dangerousGood: "",
    wholeCaseProduct: "",
    foldableProduct: "",
    bubbleMailer: "",
    fragileProduct: "",
    essentialGoods: "",
    PolyMailer: ""
  };
  productView: Inventory = {
    barCode: "",
    imageUrl: "",
    productImage: "",
    productName: "",
    productType: "",
    productAttributes: "",
    status: "",
    storeSku: "",
    weight: "",
    sku: "",
    binLocation: "",
    minQuantity: "",
    accountOwners: "",
    kitComponents: "",
    products: "",
    productId: 0,
    id: 0,
    dimensions: "",
    accountOwnerId: 0,
    organizationId: 0
  }
  value: any;
  tabClicked: string = 'attributes';

  constructor(private alertService: AlertService, private http: HttpClient, private router: Router, private route: ActivatedRoute, private api: ApiIntegration, private g: Globals, public user: User) {
    this.g.page = "Inventory view";
    this.g.loaderDisplay = "display";
    this.api.getProductListByProductId(this.route.snapshot.params['id'], this.user.accountOwnerId, this.user.organizationId).subscribe((data: any) => {
      this.g.loaderDisplay = "";
      this.productView = data;
      if (data.dimensions != null) {
        this.productView.length = data.dimensions.split("*")[0];
        this.productView.width = data.dimensions.split("*")[1];
        this.productView.height = data.dimensions.split("*")[2];
      }
    }, err => {
      this.alertService.error('Error', err);
      this.g.loaderDisplay = "";
    });

  }

  editProductSelect(productView) {
    this.router.navigate(['/admin/sellerProductsEdit/' + (productView.productId || productView.id)]);
  }

  tabChange(tab) {
    this.tabClicked = tab;
    if (this.tabClicked == 'details') {
      this.api.getOrdersDetailsByProductId(this.user.organizationId, this.route.snapshot.params['id']).subscribe((data: any) => {
        this.g.loaderDisplay = "";
        this.productView.historyActivities = data;
      }, err => {
        console.log(err);
        this.g.loaderDisplay = "";
      });
    }

  }

  copied(event) {
    if (event.isSuccess) {
      this.alertService.success(event.content, 'Copied Successfully');
    }
  }

  ngOnInit(): void {
  }
}


